import moment from 'moment'
import axios from 'axios'
import { Toast } from 'mint-ui'
// state
const state = {
    selectedOrder: [],
    orderId: '',
    line: { },
    bill: '',
    contact: {},
    tourist: {},
    remark: '',
    filter: {
        isOk: '4', // 1确认，0预留，2其他（-2 -3 -4）取消单，3所有状态订单，4有效订单
        validOrder: true,
        type: '1', // 下单日期 type=1, 出团日期 type=2
        createStartDate: moment(moment().subtract(30, 'days').calendar()).format('YYYY-MM-DD'), // 下单开始时间
        createEndDate: moment().format('YYYY-MM-DD'), // 下单结束时间
        planStartDate: moment().format('YYYY-MM-DD'), // 出团开始时间
        planEndDate: moment(moment().add(30, 'days').calendar()).format('YYYY-MM-DD'), // 出团开始时间
        skey: '', // 关键字
        pageSize: 5,
        currentPage: 1,
        storeOrdType: '' // 0代表查看自己, 1代表查看店员的订单（只有店主才传这个值）
    },
    bak: '',
    mark: '',
    idType: '',
    touristLock: ''
}

// getters
const getters = {
    selectedOrder: state => state.selectedOrder,
    lineDetail: state => state.line,
    bill: state => state.bill,
    contact: state => state.contact,
    tourist: state => state.tourist,
    remark: state => state.remark,
    filter: state => state.filter,
    bak: state => state.bak,
    mark: state => state.mark,
    idType: state => state.idType,
    touristLock: state => state.touristLock
}

// actions
const actions = {
    /* 订单详情 */
    getOrderDetail ({commit}) {
        axios.get(
            '/ms/order/52382'
        ).then(res => {
            if (res.status === 200) {
                commit('setOrderDetail', res.data.data)
            } else if (res.data.status !== 100) {
                Toast({message: res.data.msg, position: 'bottom', duration: 1000})
            }
        })
    }
}

// mutations
const mutations = {
    setOrderDetail (state, value) {
        state.line = value
    },
    setFilter (state, value) {
        state.filter = value
    },
    setFilterByKey (state, obj) {
        state.filter[obj.key] = obj.value
    },
    setStoreOrdType (state, value) {
        state.filter.storeOrdType = value
    },
    setOrder (state, value) {
        state.selectedOrder = [value]
    },
    saveBak (state, value) {
        state.bak = value
    },
    saveMark (state, value) {
        state.mark = value
    },
    saveIdtype (state, value) {
        state.idType = value
    },
    addCurrentPage (state) {
        state.filter.currentPage += 1
    },
    resetCurrentPage (state) {
        state.filter.currentPage = 1
    },
    steTouristLock (state, value) {
        state.touristLock = value
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js